"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.selectWithDigitalHig = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _caretDown = _interopRequireDefault(require("@digital-hig/icon/lib/build/ui-controls/caret-down"));

var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));

var _Select = _interopRequireDefault(require("@mui/material/Select"));

var _optionContent = _interopRequireDefault(require("./option-content"));

var _svgIcon = _interopRequireDefault(require("@digital-hig/svg-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var selectWithDigitalHig = function selectWithDigitalHig(BaseMuiSelect) {
  var Select = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
    var children = _ref.children,
        MenuProps = _ref.MenuProps,
        options = _ref.options,
        style = _ref.style,
        value = _ref.value,
        width = _ref.width,
        otherProps = _objectWithoutProperties(_ref, ["children", "MenuProps", "options", "style", "value", "width"]);

    // API: https://mui.com/material-ui/api/select/
    var muiApiPresets = {
      // autoWidth
      // children,
      // classes,
      // defaultOpen,
      // defaultValue,
      // displayEmpty,
      // eslint-disable-next-line react/display-name
      IconComponent: function IconComponent(props) {
        return /*#__PURE__*/_react.default.createElement(_svgIcon.default, props, /*#__PURE__*/_react.default.createElement(_caretDown.default, null));
      },
      // id,
      // input,
      // inputProps,
      // label,
      // labelId,
      MenuProps: _objectSpread({
        anchorOrigin: {
          horizontal: "left",
          vertical: "bottom"
        },
        elevation: 0,
        transformOrigin: {
          horizontal: "left",
          vertical: "top"
        }
      }, MenuProps) // multiple,
      // native,
      // onChange,
      // onClose,
      // onOpen,
      // open,
      // renderValue,
      // SelectDisplayProps,
      // sx,
      // value,
      // variant

    };

    if (!options) {
      return null;
    }

    var selectWidth = width ? width : "";
    var menuWidth = width ? "calc(".concat(width, " - 4px)") : "";
    return /*#__PURE__*/_react.default.createElement(BaseMuiSelect, _extends({}, muiApiPresets, otherProps, {
      style: _objectSpread(_objectSpread({}, style), {}, {
        width: selectWidth
      }),
      value: value,
      ref: ref
    }), children || options.map(function (_ref2, key) {
      var children = _ref2.children,
          optionValue = _ref2.value,
          otherOptionProps = _objectWithoutProperties(_ref2, ["children", "value"]);

      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, _extends({
        key: key,
        value: optionValue,
        style: {
          width: menuWidth
        }
      }, otherOptionProps), /*#__PURE__*/_react.default.createElement(_optionContent.default, {
        isSelected: value === optionValue
      }, children));
    }));
  });

  var defaultProps = {
    options: []
  };
  Select.displayName = "Select";
  Select.defaultProps = _objectSpread({}, defaultProps);
  Select.propTypes = {
    /**
     * Select children content
     */
    children: _propTypes.default.node,

    /**
     * MUI MenuProps object.
     */
    MenuProps: _propTypes.default.object,

    /**
     * The object used to create the list of options in the select dropdown. See https://mui.com/material-ui/api/menu-item/ for full set of options.
     */
    options: _propTypes.default.array,

    /**
     * Additional styles
     */
    style: _propTypes.default.object,

    /**
     * MUI Select value.
     */
    value: _propTypes.default.any,

    /**
     * Fixed width value.
     */
    width: _propTypes.default.string
  };
  return Select;
};

exports.selectWithDigitalHig = selectWithDigitalHig;
var SelectDhig = selectWithDigitalHig(_Select.default);
var _default = SelectDhig;
exports.default = _default;